module.exports = __webpack_public_path__ + "img/index_help_czsc@2x.72f4c9a8.png";